import React, {useEffect, useState, useCallback, useRef} from 'react';
import {connect} from 'react-redux';
import {withRouter, Link} from 'react-router-dom';
import {Menu} from '../../utils/menu/Menu';
import cfg, {courses, formatErrors, roleAdmin, userPrintName, roleTechnicalSpecialist, roleCurator} from '../../constants';
import {toast} from 'react-toastify';
import {InputDate} from '../../utils/inputSearch/InputDate';
import {SortItem} from '../../utils/sortItem/SortItem';
import {ButtonMore} from '../../utils/buttonMore/buttonMore';
import {Pagination} from '../../utils/pagination/Pagination';
import {getResponseTimeAction} from "../../actions/usersAction";
import {MenuHeader} from "../../utils/menu/MenuHeader";

const ResponseTime = (props) => {
  let nowDate = new Date();
  let nowDateStr = nowDate.toISOString().split('T')[0];

  let yesterdayDate = new Date();
  yesterdayDate.setDate(yesterdayDate.getDate() - 1);
  let yesterdayDateStr = yesterdayDate.toISOString().split('T')[0];

  const {user, isAdmin, getClients, isTechnicalSpecialist} = props;
  const [items, setItems] = useState([]);
  const [total, setTotal] = useState([]);
  const [loading, setLoading] = useState(false);
  const [filter, setFilter] = useState({date_from: yesterdayDateStr});
  const [checked, setChecked] = useState({});
  const [checkedAll, setCheckedAll] = useState(false);
  const [selectBut, setSelectBut] = useState(0);
  const abortRef = useRef(null);

  const [dateFrom, setDateFrom] = useState(yesterdayDateStr);
  const [dateTo, setDateTo] = useState('');

  const handleChangeFilter = useCallback((field, value) => {
    setSelectBut(0)
    setFilter((data) => {
      return {...data, [field]: value, page: 1, type_period: 0}
    });
  }, []);

  const handleChangePage = useCallback((value) => {
    setFilter((data) => {
      return {...data, page: value}
    });
  }, []);

  const handleChangeSort = useCallback((sort, sortd) => {
    setFilter((data) => {
      return {...data, sort, sortd}
    });
  }, []);

  // get clients list
  const getClientsList = useCallback((filter) => {
    if (abortRef && abortRef.current) {
      abortRef.current.abort();
    }
    const abortNew = new AbortController();
    abortRef.current = abortNew;
    setLoading(true)
    getClients(filter, isAdmin, abortRef && abortRef.current ? abortRef.current.signal : null, isTechnicalSpecialist).then((data) => {
      abortRef.current = null;
      setItems(data.items || []);
      setTotal(data.total);
      setChecked({});
      setCheckedAll(false);
      setLoading(false)
      //localStorage.setItem('dc_currentResponseTimeFilter', JSON.stringify(filter));
    }).catch(err => {
      if (err.name !== 'AbortError') {
        toast.error(formatErrors([err.message]), {position: toast.POSITION.BOTTOM_RIGHT});
      }
      abortRef.current = null;
    });
  }, [getClients, isAdmin, isTechnicalSpecialist]);

  const handleChecked = (id) => {
    let values = {...checked};
    if (values.hasOwnProperty(id) && values[id]) {
      delete values[id];
      setChecked(values);
      setCheckedAll(false);
    } else {
      values[id] = true;
      setChecked(values);
      setCheckedAll(items.filter(i => i.id !== id && !checked[i.id]).length === 0);
    }
  };

  const handleCheckedAll = () => {
    setCheckedAll(!checkedAll);
    setChecked(checkedAll ? {} : items.reduce((res, i) => {
      res[i.id] = true;
      return res;
    }, {}));
  };

  // get clients list on change filter
  useEffect(() => {
    if (filter.page) {
      getClientsList(filter);
    }
  }, [filter, getClientsList]);

  useEffect(() => {
    if (!user || !user.id) {
      return;
    }
    const baseFilter = {page: 1, limit: 10, date_from: yesterdayDateStr, date_to: '', type_period: 0};
    //let curFilter = localStorage.getItem('dc_currentResponseTimeFilter');
    //curFilter = curFilter ? JSON.parse(curFilter) : baseFilter;
    let curFilter = baseFilter;
    curFilter.page = !curFilter.page ? 1 : curFilter.page;
    if (user.role_id === roleCurator) {
      curFilter.curator_id = user.id;
    } else {
      curFilter.curator_id = "";
    }
    setFilter(curFilter);
  }, [user]);

  const handleChangeFilterButton = (type) => {
    setSelectBut(type)

    setFilter((data) => {
      return {...data, type_period: Number(type)}
    });
  }

  return <div className="content">
    <Menu isStatic={user.role_id === roleCurator ? false : true}/>

    <div className="heading heading--flex">
      <h2 className="heading__title">Время ответов</h2>
      <div className="heading__group">
        
      </div>

      {loading && <img src="/img/Spinner-2.gif" />}

      {filter.page && filter.page > 0 && <InputDate className=""
                                                          value={filter.date_from}
                                                          loading={loading}
                                                          handleChange={handleChangeFilter} placeholder={"Дата от"} name={"date_from"} />}
      &nbsp;
      {filter.page && filter.page > 0 && <InputDate className=""
                                                    value={filter.date_to}
                                                    loading={loading}
                                                    handleChange={handleChangeFilter} placeholder={"Дата до"} name={"date_to"} />}

      &nbsp;<span><span>&nbsp;</span><button onClick={() => handleChangeFilterButton(1)} className={selectBut === 1 ? 'heading__btn heading__btn--transparent change-date select-but':'heading__btn heading__btn--transparent change-date'}>Сегодня</button></span>
      &nbsp;<span><span>&nbsp;</span><button onClick={() => handleChangeFilterButton(2)} className={selectBut === 2 ? 'heading__btn heading__btn--transparent change-date select-but':'heading__btn heading__btn--transparent change-date'}>Вчера</button></span>
      &nbsp;<span><span>&nbsp;</span><button onClick={() => handleChangeFilterButton(3)} className={selectBut === 3 ? 'heading__btn heading__btn--transparent change-date select-but':'heading__btn heading__btn--transparent change-date'}>7-мь дней</button></span>
      &nbsp;<span><span>&nbsp;</span><button onClick={() => handleChangeFilterButton(4)} className={selectBut === 4 ? 'heading__btn heading__btn--transparent change-date select-but':'heading__btn heading__btn--transparent change-date'}>месяц</button></span>

    </div>

    <div className="users">
      <div className="users__wrapper">
        <div className="sort">
          <SortItem title="Фио куратора" className="sort__item--name" sort="curators_name" sortd={filter.sort === "curators_name" ? filter.sortd : ""} onChange={handleChangeSort}/>
          <SortItem title="Среднее время ответа" className="sort__item--name" sort="average_response_time" sortd={filter.sort === "average_response_time" ? filter.sortd : ""} onChange={handleChangeSort}/>
          <SortItem title="Топ 3 пауз между ответами" className="sort__item--name" sort="top_3_pauses_between_answers" sortd={filter.sort === "top_3_pauses_between_answers" ? filter.sortd : ""} onChange={handleChangeSort}/>
          <SortItem title="" className="sort__item--name" />
          <SortItem title="" className="sort__item--name" />
        </div>
        <div className="users__inner">
          {
            items && items.length > 0 && items.map((i) => <div key={i.id} className="users__item">
              <span className="users__name">{i.last_name} {i.first_name}</span>
              <span className="users__name">{i.average_response_time_all}</span>
              <span className="users__name">
                {i.top_3_pauses_between_answers_all.map((j, iter) => <div key={iter} className={j.time_answer > 60 ? 'itemRed':''}>{j.time_answer_str} ({j.time_start} - {j.time_end})</div>)}
                {i.sum_top_3_pauses_between_answers_all && <div>Общее время пауз: {i.sum_top_3_pauses_between_answers_all}</div>}
              </span>
            </div>)
          }
        </div>
      </div>
    </div>

    {filter.page && filter.page > 0 && <Pagination page={filter.page} total={total} limit={filter.limit} onChange={handleChangePage}/>}
  </div>;
};

const mapStateToProps = (state) => ({
  user: state.user.profile,
  isAdmin: state.user.profile && state.user.profile.role_id === roleAdmin,
  isTechnicalSpecialist: state.user.profile && state.user.profile.role_id === roleTechnicalSpecialist
});

const mapDispatchToProps = (dispatch) => {
  return {
    getClients(data, isAdmin, signal) {
      return dispatch(getResponseTimeAction(data, signal));
    }
  }
};

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(ResponseTime))
